// https://gitlab.com/shelters-finance/api/-/feature_flags
export enum FEATURE_FLAG {
  MIGRATE_TO_PASSKEY = 'migrate-to-passkey',
  WALLET_BALANCE = 'wallet-balance',
  DEBUG_MVX = 'debug-mvx',
  PASSKEY_LOGIN = 'passkey-login',
  OFF_RAMP = 'off-ramp',
  ON_RAMP = 'on-ramp',
  CAN_CHANGE_WALLET = 'can-change-wallet',
  PAY_WITH_BANK_TRANSFER = 'pay-with-bank-transfer',
  PAY_WITH_BALANCE = 'pay-with-balance',
  SHOW_INTERNAL_ISSUE = 'show-internal-issue',
  INVESTMENT_SUMMARY = 'investment-summary',
}
